import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { CookieKeys } from '@core/const';
import { CookieService, FeatureFlagService } from '@core/feature';
import { map, Observable } from 'rxjs';

export const checkoutV2Guard: CanMatchFn = (): Observable<boolean> => {
  const cookieService = inject(CookieService);
  const featureFlagService = inject(FeatureFlagService);

  return featureFlagService
    .isEnabled('chekoutV2Enabled')
    .pipe(map((isEnabled) => isEnabled || cookieService.hasKey(CookieKeys.ChekoutV2Enabled)));
};
